import { useId } from "react";

export function InfinityLogo({ className = "", width = 51, height = 30 }) {
  const raw = useId().replace(/:/g, "");
  return (
    <svg width={width} height={height} viewBox="0 0 68 40" className={`infinity-logo ${className}`} aria-label="AgriVoice logo">
      <defs>
        <linearGradient id={`${raw}-g1`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4ADE80" />
          <stop offset="100%" stopColor="#16A34A" />
        </linearGradient>
        <linearGradient id={`${raw}-g2`} x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FBBF24" />
          <stop offset="100%" stopColor="#D97706" />
        </linearGradient>
        <filter id={`${raw}-glow`} x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation="1.6" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter={`url(#${raw}-glow)`}>
        <path className="inf-leaf inf-leaf-left" d="M34 20 C30 6, 6 2, 6 20 C6 38, 30 34, 34 20 Z" fill={`url(#${raw}-g1)`} />
        <path className="inf-leaf inf-leaf-right" d="M34 20 C38 6, 62 2, 62 20 C62 38, 38 34, 34 20 Z" fill={`url(#${raw}-g2)`} />
        <path d="M34 20 C30 6, 6 2, 6 20 C6 38, 30 34, 34 20 C38 6, 62 2, 62 20 C62 38, 38 34, 34 20" fill="none" stroke="#ECFDF5" strokeWidth="1.3" strokeLinecap="round" className="inf-trace" />
        <path d="M10 20 C18 18, 26 20, 34 20" stroke="#06110A" strokeWidth="0.9" fill="none" opacity="0.5" />
        <path d="M34 20 C42 20, 50 22, 58 20" stroke="#1A1000" strokeWidth="0.9" fill="none" opacity="0.5" />
      </g>
    </svg>
  );
}
